import { useNavigate } from 'react-router-dom';
import Footer from '../Footer';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <>
      <div>
        <div className="min-h-screen bg-[#050B18] text-white font-Gabarito flex flex-col">
          <div className="px-6 py-6 md:px-32 bg-[#050B18]">
            <div className="flex flex-wrap items-center justify-between">
              <img
                src="/images/logoWithText.svg"
                className="h-12 cursor-pointer"
                alt="logo"
                onClick={() => navigate('/')}
              />
            </div>
          </div>
          <div className="text-white  font-inika px-6 md:px-20 py-16 w-full  leading-7">
            <h1 className="text-4xl font-bold mb-10 text-center">PRIVACY POLICY</h1>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">1. Information We Collect</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Personal details (name, email, phone)</li>
                <li>Profile information</li>
                <li>Usage behavior (clicks, activity, interactions)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">2. Purpose of Data Collection</h2>
              <p className="mb-3">We use data to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Operate the platform</li>
                <li>Manage participation</li>
                <li>Improve user experience</li>
                <li>Prevent fraud or misuse</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">3. Data Sharing</h2>
              <p className="mb-3">We may share data with:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Hosting and tech providers</li>
                <li>Analytics services</li>
                <li>Legal authorities (if required)</li>
              </ul>
              <p className="mt-3 text-green-400">👉 We do NOT sell your personal data.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">4. Cookies & Tracking</h2>
              <p className="mb-3">Used for:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Performance tracking</li>
                <li>User experience improvement</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">5. Data Security</h2>
              <p>We apply reasonable safeguards, but no system is completely secure.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">6. User Rights</h2>
              <p className="mb-3">Users may:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Request access</li>
                <li>Request correction</li>
                <li>Request deletion</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">7. Data Retention</h2>
              <p>Data is stored only as long as necessary.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">8. Third-Party Services</h2>
              <p>Third-party tools may have separate privacy policies.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">9. Age Restriction</h2>
              <p>Not intended for users under 18.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-3">10. Updates</h2>
              <p>Policy may change anytime.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">11. Contact</h2>
              <p>
                📧{' '}
                <a href="mailto:info@decentden.com" className="underline text-blue-400">
                  info@decentden.com
                </a>
              </p>
            </section>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
